module.exports = __webpack_public_path__ + "static/img/logo-alt.128ff3c1.svg";